import React, { useEffect } from "react";
import css from "./.module.scss";
import Image from "next/image";
import { Modal } from "@aqar-app/react-ui";
import { mapGraphqlErrors } from "@/lib/error";
import logger from "@/console";

const E_CODES = {
  CASE_1: "0x14EC",
  CASE_2: "0x24EC",
  CASE_3: "0x34EC",
  CASE_4: "0x44EC",
  CASE_5: "0x54EC",
  CASE_6: "0x64EC",
};
function BasicError({
  errors = [],
  image,
  code = "0x16ED55",
  title = "حدث خطـأ",
}) {
  return (
    <div className={css.baseError}>
      <div className={css.imgWrapper}>
        <Image unoptimized fill src={image} alt="404-not-found" />
      </div>
      <h3>{title}</h3>
      {errors.map((e, i) => (
        <p key={i}> {e.message}</p>
      ))}
    </div>
  );
}
export function SSRError({ error }) {
  useEffect(() => {
    logger.log(error);
  }, [error]);
  if (error.networkError) {
    return (
      <BasicError
        code={E_CODES["CASE_1"]}
        image="https://assets.aqar.fm/icons/404-not-found.svg"
        errors={error.networkError.result?.errors}
      />
    );
  }

  if (error.graphQLErrors)
    return (
      <BasicError
        code={E_CODES["CASE_2"]}
        image="https://assets.aqar.fm/icons/404-not-found.svg"
        errors={error.graphQLErrors}
      />
    );

  if (error.errors)
    return (
      <BasicError
        code={E_CODES["CASE_3"]}
        image="https://assets.aqar.fm/icons/404-not-found.svg"
        errors={error.errors}
      />
    );
  if (typeof error == "string")
    return (
      <BasicError
        code={E_CODES["CASE_4"]}
        image="https://assets.aqar.fm/icons/404-not-found.svg"
        errors={[{ message: error }]}
      />
    );

  if (error?.message)
    return (
      <BasicError
        code={E_CODES["CASE_5"]}
        image="https://assets.aqar.fm/icons/404-not-found.svg"
        errors={[error]}
      />
    );

  return (
    <BasicError
      code={E_CODES["CASE_6"]}
      image="https://assets.aqar.fm/icons/404-not-found.svg"
      errors={[{ message: JSON.stringify(error) }]}
    />
  );
}

export const Linkify = ({ text }) => {
  const formatter = (str) => `<a href="${str}">${str}</a>`;
  if (text?.code === 404) return <p>{text.error}</p>;
  const hasLink = text.includes("http");
  const __html = text.replace(/((http:|https:)[^\s]+[\w])/g, formatter);
  return hasLink ? (
    <div dangerouslySetInnerHTML={{ __html }} className={css.linkify} />
  ) : (
    <p>{text}</p>
  );
};

export const ErrorModal = function ErrorModal({ errors, footer, className }) {
  return (
    <Modal.ClassicOverlay className={css.modal + " " + (className || "")}>
      <div>
        <h3>حدث خطأ</h3>
        <Modal.CloseButton />
      </div>
      <div>
        {errors ? (
          <>
            {typeof errors.map === "function" ? (
              errors.map(({ message }) => (
                <Linkify key={message} text={message || ""} />
              ))
            ) : (
              <Linkify text={errors.message || ""} />
            )}
          </>
        ) : (
          "الرجاء المحاولة مرة أخر أو التواصل مع الدعم"
        )}
      </div>
      {footer}
    </Modal.ClassicOverlay>
  );
};

ErrorModal.handle = (errors, callback, props) =>
  Modal.open(
    <ErrorModal {...(props || {})} errors={mapGraphqlErrors(errors)} />,
    {
      onClose: () => {
        if (typeof callback === "function") callback?.();
      },
    },
  )({
    target: document.body,
  });
